import TrackShell from "@/components/track/TrackShell";

export default function TrackOrgDashboard() {
  return <TrackShell roleLabel="Origin Track OS · Organization" />;
}
